
const config = 'https://api.budandtulips.com'

export default config